import type { TFunction, TOptions } from 'i18next';

export const translateOptions = (
  options: { value: string; label: string }[],
  t: TFunction,
  tParams: TOptions = {},
) =>
  options.map((option) => ({
    value: option.value,
    label: t(option.label, tParams),
  }));

export const toValidUrl = (url: string) => {
  try {
    const validUrl = /^https?:\/\/.*$/.test(url) ? url : `https://${url}`;

    return new URL(validUrl).toString();
  } catch {
    return undefined;
  }
};
